import { faPhoneOffice, faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { CallTemplate } from 'bundles/connect/types';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, ListGroup, Row, Spinner } from 'react-bootstrap-5';
import { getCallTemplates } from 'bundles/connect/helpers/prospect_api';
import CallTemplateRow from './call_template_row';
import EmptyState from 'shared/empty_state';
import CallTemplateModal from './call_template_modal';

export default function CallTemplates() {
  const [templates, setTemplates] = useState<CallTemplate[]>();
  const [show, setShow] = useState(false);
  const [template, setTemplate] = useState<CallTemplate | undefined>(undefined);

  const handleShowModal = () => {
    setTemplate(undefined);
    setShow(true);
  };

  useEffect(() => {
    getCallTemplates()
      .then((response) => {
        setTemplates(response);
      });
  }, []);

  return (
    <>
      <Card.Header>
        <Row className="align-items-center">
          <Col>
            <h4 className="m-0">Call Templates</h4>
          </Col>
          <Col xs="auto">
            <Button disabled={!templates} type="button" variant="secondary" onClick={handleShowModal}>
              <FontAwesomeIcon icon={faPlus} />
              Add New Template
            </Button>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body>
        <ListGroup>
          {!templates && (
            <div className="text-center">
              <Spinner animation="border" variant="secondary" />
            </div>
          )}
          {templates?.length === 0 && (
            <EmptyState
              bodyText="Call templates allow you to quickly iterate
              over your lists using predefined templates. Try setting up a new one now!"
              header="You haven't added any call templates."
              icon={faPhoneOffice}
            />
          )}
          {templates?.map(template => (
            <CallTemplateRow
              key={template.id}
              setShow={setShow}
              setTemplate={setTemplate}
              setTemplates={setTemplates}
              template={template}
            />
          ))}
        </ListGroup>
      </Card.Body>
      <CallTemplateModal setShow={setShow} setTemplates={setTemplates} show={show} template={template} />
    </>
  );
}
